export enum TimePeriod {
  WEEK,
  MONTH,
  HALF_YEAR,
  YEAR,
}
